import {
  createContext,
  MutableRefObject,
  ReactNode,
  useContext,
  useRef,
  useState,
} from 'react';

import { IFCWithChildren } from '../interfaces/i-fc-with-children';
import { useMediaQuery } from '../hooks/use-media-query';

interface IPrivateLayoutContextData {
  mobileHeaderTopRightContent: ReactNode;
  bodyRef: MutableRefObject<HTMLDivElement>;
  isMobile: boolean;
  renderMobileHeaderTopRightContent: (content: ReactNode) => void;
}

const PrivateLayoutContext = createContext({} as IPrivateLayoutContextData);

interface IPrivateLayoutProviderProps {
  isMobile: boolean;
}
const PrivateLayoutProvider: IFCWithChildren<IPrivateLayoutProviderProps> = ({
  children,
  isMobile: isMobileInitialProps,
}) => {
  const isMobile = useMediaQuery('(max-width: 750px)') || isMobileInitialProps;
  const bodyRef = useRef<HTMLDivElement>(null);

  const [mobileHeaderTopRightContent, setMobileHeaderTopRightContent] =
    useState<ReactNode>(null);

  const renderMobileHeaderTopRightContent = (content: ReactNode): void => {
    setMobileHeaderTopRightContent(content);
  };

  return (
    <PrivateLayoutContext.Provider
      value={{
        bodyRef,
        isMobile,
        mobileHeaderTopRightContent,
        renderMobileHeaderTopRightContent,
      }}
    >
      {children}
    </PrivateLayoutContext.Provider>
  );
};

const usePrivateLayout = (): IPrivateLayoutContextData => {
  return useContext(PrivateLayoutContext);
};

export { PrivateLayoutProvider, usePrivateLayout };
